module.exports = __webpack_public_path__ + "static/media/44-1.671f0b87.mp3";